import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { loadRecurringPayment } from "../../Containers/Settings/actions";
import { dateFormats } from "../../utility/enums";
import { today as todayDate } from "../../utility/commonHelpers";
import { optedPlan, paymentWebhook, paymentClose, checkOutPayment } from "../../common/actions";
import { PAYMENT_URL_DOMAIN_PROD, PAYMENT_URL_DOMAIN_TIER1, PAYMENT_URL_DOMAIN_STAGING } from "../../common/constants";
import { getMessage } from "../../utility/Messages";
import { showAlert } from "../../utility/alertHelper";
import Session from "../../utility/session";
const mapStateToProps = state => ({
  recurringPayment: state.settingsInfo.recurringPayment,
  subscribePlanInfo: state.subscribePlanInfo
});
class RecurringPayment extends Component {
  constructor(props) {
    super(props);
    this.renewalPlan = this.renewalPlan.bind(this);
    this.closeFrame = this.closeFrame.bind(this);
  }
  componentDidMount() {
    window.addEventListener("message", receiveMessage.bind(this), false);
    function receiveMessage(event) {
      let PAYMENT_URL_DOMAIN;
      if (process.env.REACT_APP_ENV == "production") {
        PAYMENT_URL_DOMAIN = PAYMENT_URL_DOMAIN_PROD;
      } else if (process.env.REACT_APP_ENV == "staging") {
        PAYMENT_URL_DOMAIN = PAYMENT_URL_DOMAIN_STAGING;
      } else {
        PAYMENT_URL_DOMAIN = PAYMENT_URL_DOMAIN_TIER1;
      }
      if (event.origin.indexOf(PAYMENT_URL_DOMAIN) > -1) {
        this.props.dispatch(
          paymentWebhook({ paymentDetails: event.data, invoiceInfo: this.props.subscribePlanInfo.invoiceInfo })
        );
      }
    }
    const currentUserName = window.localStorage.getItem(Session.CURRENT_USER_NAME)
    if(currentUserName !== "techsupport@magazinemanager.com"){
      // showAlert(getMessage("old_new_passwords_matched"));
      // setTimeout(() => {
        this.props.history.push(`/email-verification`)
      // }, 3000);
    } else {
      this.props.dispatch(loadRecurringPayment());
    }
  }
  closeFrame() {
    this.props.dispatch(paymentClose());
    if (this.props.subscribePlanInfo.paymentPending) {
      const paymentDetails = {};
      paymentDetails.status = "cancelled";
      this.props.dispatch(
        paymentWebhook({
          paymentDetails: JSON.stringify(paymentDetails),
          invoiceInfo: this.props.subscribePlanInfo.invoiceInfo
        })
      );
    }
  }
  renewalPlan(
    mmcustomerid,
    planGroupID,
    planname,
    planid,
    daycredits,
    amount,
    FreequencyId,
    Freequency,
    planGroup,
    planType
  ) {
    const that = this;
    return function(event) {
      debugger;
      const today = todayDate();
      const invoice = {};

      //Adjustment amount
      invoice.adjustment = 0;

      invoice.planGroupID = planGroupID;
      invoice.planID = planid;
      invoice.orderDate = today;
      invoice.price = amount;
      invoice.customersID = mmcustomerid;
      invoice.size = daycredits;
      invoice.FreequencyId = FreequencyId;
      invoice.Freequency = Freequency;
      invoice.planGroup = planGroup;
      invoice.discountedprice = amount;
      invoice.perMonthPrice = 0;
      invoice.planType = planType;
      invoice.planexpireson = today.add(parseInt(Freequency), "months").format("MMM DD,YYYY");
      that.props.dispatch(optedPlan({ planDetails: invoice }));
      that.props.dispatch(checkOutPayment({ invoiceInfo: invoice }));
    };
  }
  render() {
    const today = todayDate().format("MMM DD,YYYY");
    const recurringPayment = this.props.recurringPayment;
    return (
      <div class="right_col" role="main">
        <div class="">
          <div class="page-title">
            <div class="title_left">
              <h3>Recurring Payment</h3>
            </div>
            <div class="title_right" />
            <div class="clearfix" />
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="x_panel">
                  <div class="x_content">
                    <div class="col-md-12 col-sm-12 col-xs-12" style={{ padding: 0 }}>
                      <div class="" role="tabpanel" data-example-id="togglable-tabs">
                        <table className="data table table-striped no-margin">
                          <thead>
                            <tr>
                              <th width="5%">UserID</th>
                              <th width="30%">Name</th>
                              <th width="20%">Username</th>
                              <th width="20%">Plan(Credits)</th>
                              <th width="20%">Plan Expires On</th>
                              <th width="8%">Renewal</th>
                            </tr>
                          </thead>
                          <tbody>
                            {recurringPayment.length > 0 &&
                              recurringPayment.map((payment, index) => (
                                <tr key={index}>
                                  <td>{payment.userId}</td>
                                  <td>{payment.name} </td>
                                  <td>{payment.username}</td>
                                  <td>
                                    {payment.plan}({payment.daycredits})
                                  </td>
                                  <td>{new moment(payment.planexpireson).format(dateFormats.DISPLAY_DATE_TIME)}</td>
                                  <td>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={this.renewalPlan(
                                        payment.mmcustomerid,
                                        payment.PlanGroupID,
                                        "Credits:" + payment.daycredits,
                                        payment.PlanID,
                                        payment.daycredits,
                                        payment.amount,
                                        payment.FrequencyId,
                                        payment.Frequency,
                                        payment.plan,
                                        "daily"
                                      )}
                                      className={
                                        moment(payment.planexpireson).format("MMM DD,YYYY") === today
                                          ? "btn btn-primary buttonBorder todayExpiry"
                                          : "btn btn-primary buttonBorder"
                                      }
                                      data-page="portfolio"
                                    >
                                      Renewal
                                    </a>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.props.subscribePlanInfo.paymentURL === "" ? null : (
          <div id="overlay" class="overlay">
            <div class="payment-modal">
              <a style={{ fontSize: "24px" }} href="#" onClick={this.closeFrame} class="close-sign">
                <i class="fa fa-times" aria-hidden="true" />
              </a>
              <iframe style={{ width: "100%", height: "100%" }} src={this.props.subscribePlanInfo.paymentURL} />
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps)(RecurringPayment);



// WEBPACK FOOTER //
// ./src/components/RecurringPayment/RecurringPayment.js